<template>
  <Card class="pa-4">
    <FlexColumn>
      <Label size="h6" bold text="スキル" />
      <FlexColumn class="properties">
        <FlexColumn v-if="data">
          <Label text="経験のあるデータ" />
          <Label bold :text="data" />
        </FlexColumn>
        <FlexColumn v-if="exist(applicant.skills.domain) || exist(applicant.skills.otherDomain)">
          <Label text="経験のあるドメイン" />
          <Label bold :text="experiencedDomainsLabel(applicant.skills.domain, applicant.skills.otherDomain)" />
        </FlexColumn>
        <FlexColumn v-if="exist(applicant.skills.tools) || exist(applicant.skills.otherTools)">
          <Label text="経験のあるサービス・ツール" />
          <Label bold :text="experiencedToolsLabel(applicant.skills.tools, applicant.skills.otherTools)" />
        </FlexColumn>
        <FlexColumn v-if="languages">
          <Label text="経験のあるプログラミング言語" />
          <Label bold :text="languages" />
        </FlexColumn>
        <FlexColumn v-if="applicant.skills.about">
          <Label text="自己PR（実績など）" />
          <TextView bold :text="applicant.skills.about" />
        </FlexColumn>
      </FlexColumn>
    </FlexColumn>
  </Card>
</template>

<script>
import Card from "@/components/atoms/Card";
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import TextView from "@/components/atoms/TextView";
import ComponentMixin from "@/components/ComponentMixin";
import {mapGetters} from "vuex";

export default {
  mixins: [ComponentMixin],
  name: "ApplicantSkillsCard",
  components: {TextView, Label, FlexColumn, Card},
  props: {
    applicant: {
      type: Object
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    data() {
      return this.applicant.skills.data.map(value => this.constsToText(value, this.consts.dataGoodAt)).join("、")
    },
    languages() {
      return this.applicant.skills.languages.map(value => this.constsToText(value, this.consts.programmingLanguages)).join("、")
    }
  },
  methods: {
    exist(value) {
      return value && value.length > 0
    }
  }
}
</script>

<style scoped>
.properties > *:not(:last-child) {
  border-bottom: rgba(0, 0, 0, 0.12) solid thin;
  margin-bottom: 8px;
  padding-bottom: 8px;
}
</style>